var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    points: "18.878 6 8.999 15.879 8.999 15.879 5.121 12 3 12 7.939 16.939 8.999 18 10.061 16.939 21 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/Check_white.cd840df4561030b5117e047265731a1a.svg";
export { ForwardRef as ReactComponent };